import { useLazyQuery } from '@apollo/client'
import { Box, Menu, Tooltip } from '@mantine/core'

import { GET_VOICE_AGENTS } from 'src/graphql/voiceAgents.graphql'
import IconVoiceMail from 'src/icons/IconVoiceMail'
import { formatSnakeValue } from 'src/lib/formatters'

const VoiceAgentsMenu = ({ onSelect, calling }) => {
  const [loadVoiceAgents, { data: voiceAgentsData, loading }] = useLazyQuery(
    GET_VOICE_AGENTS,
    {
      variables: { pageInfo: { offset: 0, limit: 100 } },
    }
  )

  const voiceAgents = voiceAgentsData?.voiceAgents?.items || []

  return (
    <Menu
      shadow="md"
      position="bottom-end"
      onOpen={() => {
        if (!voiceAgentsData) {
          loadVoiceAgents({ variables: { pageInfo: { offset: 0, limit: 100 } } })
        }
      }}
    >
      <Menu.Target>
        <Tooltip label="Call the applicant via the voice agent" className="text-xs">
          <Box
            data-testid="voice-agent-menu-trigger"
            className="hover:cursor-pointer hover:bg-doubleNickel-gray-100 hover:stroke-doubleNickel-brand-500"
          >
            <IconVoiceMail
              className={`h-3 fill-none stroke-doubleNickel-brand-500 ${
                calling ? 'animate-spin' : ''
              }`}
            />
          </Box>
        </Tooltip>
      </Menu.Target>
      <Menu.Dropdown>
        {voiceAgents.map((voiceAgent) => (
          <Menu.Item
            key={voiceAgent.voiceAgentId}
            className="text-xs"
            onClick={() => onSelect(voiceAgent.voiceAgentId)}
          >
            {`${formatSnakeValue(voiceAgent.direction)} - ${voiceAgent.name}`}
          </Menu.Item>
        ))}
        {voiceAgents.length === 0 && !loading && (
          <Menu.Item disabled>No voice agents available</Menu.Item>
        )}
      </Menu.Dropdown>
    </Menu>
  )
}

export default VoiceAgentsMenu
